export const removeNullKeys = (obj) => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(removeNullKeys).filter((item) => item !== null);
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const cleanedValue = removeNullKeys(value);
    if (cleanedValue !== null) {
      acc[key] = cleanedValue;
    }
    return acc;
  }, {});
};
